module.exports = __webpack_public_path__ + "static/media/pdf.26cdf020.svg";